// Copyright 2022, Imprivata, Inc.  All rights reserved.

import { Button } from '@imprivata-cloud/patient-access-ui-components';
import { Flex, Typography } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface PatientConsentDeclineScreenProps {
  redirectUrl: string | null;
  onGoBack: () => void;
}

export const PatientConsentDeclineScreen = ({
  redirectUrl,
  onGoBack,
}: PatientConsentDeclineScreenProps) => {
  const { t } = useTranslation();
  const [redirecting, setRedirecting] = useState(false);

  if (redirecting) {
    return (
      <Flex vertical align="center" className="w-100" gap={16} data-testid="patient-consent-redirecting">
        <Typography.Title level={3} className="text-center">
          {t('consentPage.youre-being-redirected-to-the-application')}
        </Typography.Title>
        <Typography.Text className="text-center">
          {t('consentPage.you-may-close-this-window')}
        </Typography.Text>
      </Flex>
    );
  }

  return (
    <Flex vertical align="center" className="w-100" gap={16} data-testid="patient-consent-decline-screen">
      <Typography.Title level={3} className="text-center">
        {t('patientConsentPage.declineTitle')}
      </Typography.Title>
      <Typography.Text className="text-center">
        {t('patientConsentPage.declineText')}
      </Typography.Text>
      <Button
        variant="primary"
        onClick={onGoBack}
        label={t('patientConsentPage.goBackButton')}
        className="w-100"
        data-testid="go-back-button"
      />
      {redirectUrl ? (
        <Button
          variant="secondary"
          onClick={() => {
            setRedirecting(true);
            window.location.assign(redirectUrl);
          }}
          label={t('patientConsentPage.returnToMyChartButton')}
          className="w-100"
          data-testid="return-to-mychart-button"
        />
      ) : (
        <Typography.Text className="text-center">{t('patientConsentPage.closeWindow')}</Typography.Text>
      )}
    </Flex>
  );
};
